import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'regenerator-runtime/runtime';
import Aegis from '@tencent/aegis-web-sdk';
import store from './store';
import App from './App';
import { Report, report } from 'store/report';

declare global {
  interface Window {
    aegis: Aegis;
  }
}

if (location.host === 'isv.e.qq.com') {
  window.aegis = new Aegis({
    id: 'BiySrgjBMXoWkLMaBZ',
    reportApiSpeed: true,
    reportAssetSpeed: true,
  });

  // window.aegis = new Aegis({
  //   id: 'r5KEaCl81j8Ol11pjY', // 上报 id
  //   reportApiSpeed: true, // 接口测速
  //   reportAssetSpeed: true, // 静态资源测速
  //   spa: true, // spa 应用页面跳转的时候开启 pv 计算
  // });
}

document.addEventListener('click', (e) => {
  const { track, url, clientId } = (e.target as HTMLElement)?.dataset;
  if (!track) {
    return;
  }

  const data: Report = { event: track };
  if ((e.target as HTMLAnchorElement).href) {
    data.url = (e.target as HTMLAnchorElement).href;
  }
  if (url) {
    data.url = url;
  }
  if (clientId) {
    data.client_id = clientId;
  }
  report(data);
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// @ts-ignore
module?.hot?.accept();
